import React, {Fragment} from 'react';
import {reach} from 'hoek';
import {Header} from '../../presentational/Header/Header';
import HomePageContainer from '../HomePageContainer/HomePageContainer';
import ArticleContainer from '../ArticleContainer/ArticleContainer';
import CategoryContainer from '../CategoryContainer/CategoryContainer';

import {categoryLookup} from 'utils/utils';
import withQuery from 'utils/withQuery';

const Page = (props) => {
    const {slug, allCategories, ...rest} = props;
    let category;
    const pageSlug = `/${slug}`;

    if (pageSlug === '/') {
        return <HomePageContainer {...rest} />;
    }

    category = categoryLookup(allCategories, 'path', pageSlug);
    if (category && category.path === pageSlug) {
        return <CategoryContainer categoryId={category.sys.id} {...props} />;
    }

    return <ArticleContainer {...props} category={category} />;
};

export const LoadedPage = (props) => {
    const {response, systemData, match, location, homeRoute, preview} = props;
    const {isMobile} = systemData;
    const slug = match.params.slug || '';
    const categories = reach(response, 'data.allCategories.items');
    const translations = reach(response, 'data.translationsCollection.items.0');
    const homeId = reach(response, 'data.homeCollection.items.0.sys.id');
    const socialShares = reach(
        response,
        'data.homeCollection.items.0.socialShare',
    );
    const navigation = categoryLookup(categories, 'parentId', homeId);

    return (
        <Fragment>
            <Header
                allCategories={categories}
                categories={
                    navigation && !Array.isArray(navigation)
                        ? [navigation]
                        : navigation
                }
                translations={translations}
                systemData={systemData}
                isMobile={isMobile}
                slug={slug}
                location={location}
                homeRoute={homeRoute}
            />
            <Page
                allCategories={categories}
                translations={translations}
                systemData={systemData}
                homeId={homeId}
                slug={slug}
                preview={preview}
                location={location}
                socialShares={socialShares}
            />
        </Fragment>
    );
};

export default withQuery(LoadedPage);
